export default class EmbedShare {
  constructor({ $element: $element }) {
    this.$element = $($element);
    this.widgetDOM = this.$element.closest('div.widget');
  }

  init() {
    this.bindOnClick();
    this.bindOnClose();
  }

  bindOnClick() {
    this.$element.on('click', function(e) {
      e.preventDefault();
      this.showModal();
    }.bind(this));
  }

  bindOnClose() {
    var widgetModalDOM = this.widgetDOM.find('.widget__modal');
    var buttonCloseModalDOM = widgetModalDOM.find('.widget__modal__button-close');

    buttonCloseModalDOM.on('click', function(e) {
      e.preventDefault();
      this.closeModal();
    }.bind(this));
  }

  showModal() {
    this.widgetDOM.addClass('widget-with-modal');
  }

  closeModal() {
    this.widgetDOM.removeClass('widget-with-modal');
  }
}
